<!--
  Root template of the Provisionssatz OBC. Branches by view mode only — the exact shape of
  cp-provision-agent-object.component.html. The `initialized && dto` guard is mandatory: no dto
  exists before that. `handleNavigationItems($event)` passes the Base component's navItems
  through to the frame's object navigation.
-->
@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {

        <cp-provision-contract-agent-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-contract-agent-side>

    } @else {

        <cp-provision-contract-agent-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-contract-agent-full>

    }

}
